export const MENU_TYPE_SOURCE = [
  { value: 1, label: 'サブメニュー非表示' },
  { value: 0, label: 'サブメニュー含めて表示' },
  { value: 2, label: 'サブメニューのみ表示' },
];
